export default {
  en: require("./en.json"),
  in: require("./in.json"),
  ms: require("./ms.json"),
  vi: require("./vi.json"),
  de: require("./de.json"),
  es: require("./es.json"),
};
